import React from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { AboveInformationCorrect, CVVNumber, CardNumber, Expiration, PlaceholderName, UploadDocumentation } from "../../../../../../constants";
import { InfoFormProps } from "../../../../../../types/Forms";

const CartInfoForm: React.FC<InfoFormProps> = ({ register, errors, updateFormData, formData }) => {
  return (
    <Form className="needs-validation custom-input" noValidate>
      <Row className="g-3">
        <Col md="12">
          <Label>{PlaceholderName}</Label>
          <Input {...register("placeHolderName", { required: "Placeholder name is required" })} value={formData.placeHolderName} onChange={updateFormData} type="text" placeholder="Placeholder name" />
          {errors.placeHolderName && <span className="text-danger">{errors.placeHolderName.message}</span>}
        </Col>
        <Col xxl="4" sm="6">
          <Label>{CardNumber}</Label>
          <Input {...register("cardNumber", { required: "Card number is required" })} value={formData.cardNumber} onChange={updateFormData} type="text" placeholder="xxxx xxxx xxxx xxxx" />
          {errors.cardNumber && <span className="text-danger">{errors.cardNumber.message}</span>}
        </Col>
        <Col xxl="4" sm="6">
          <Label>{Expiration}</Label>
          <Input {...register("expiration", { required: "Expiration number is required" })} value={formData.expiration} onChange={updateFormData} type="number" placeholder="xx/xx" />
          {errors.expiration && <span className="text-danger">{errors.expiration.message}</span>}
        </Col>
        <Col xxl="4">
          <Label>{CVVNumber}</Label>
          <Input {...register("cvvNumber", { required: "CVV number is required" })} value={formData.cvvNumber}  onChange={updateFormData} type="text" />
          {errors.cvvNumber && <span className="text-danger">{errors.cvvNumber.message}</span>}
        </Col>
        <Col xs="12">
          <Label>{UploadDocumentation}</Label>
          <Input {...register("uploadDocumentation", { required: "File is required" })} onChange={updateFormData} type="file" />
          {errors.uploadDocumentation && <span className="text-danger">{errors.uploadDocumentation.message}</span>}
        </Col>
        <Col xs="12">
          <FormGroup check>
            <Input id="invalidCheck-a" {...register("informationCheckBox", { required: true })} onChange={updateFormData} type="checkbox" required />
            <Label htmlFor="invalidCheck-a" check>{AboveInformationCorrect}</Label>
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};
export default CartInfoForm;
